//Main page
export const ABOUT_ME_PATH = '/aboutme';
export const HIRE_ME_PATH = 'https://www.linkedin.com/in/artiomb5/';
export const GET_CV = 'https://disk.yandex.by/d/ThImiJdKxnnQNQ';
export const MY_WORK_PATH = '/mywork';

export const ABOUT_ME_TITLE = "About me";
export const HIRE_ME_TITLE = "Hire Me Now!";
export const GET_CV_TITLE = "Get CV";
export const MY_WORK_TITLE = "My Work";

//Projects links
export const PROJECTS_LIST_TITLE = 'Projects';

export const GITHUB_SEARCH_TEST_TASK_TITLE = "Github Search Test Task";
export const USERS_LIST_TEST_TASK_TITLE = "Users list Test Task";
export const HUAWEI_DEVICE_CATALOG_TITLE = "HUAWEI Device Gallery";
export const KANBAN_TITLE = "Kanban Desk";
export const CURRENCY_CONVERTER_TITLE = "Currency Converter";
export const ONLINE_LEARNING_APP_TITLE = "Online Learning App";
export const HUAWEI_NOVA8_LADING_TITLE = "HUAWEI NOVA 8 Landing Page";
export const UMD_STATIC_SITE_TITLE = "Underground Mining Department";
export const HUAWEI_WATCH_GT_2_PAGE_TITLE = "HUAWEI WATCH GT 2 Page";
export const APPLE_EVENT2021_PAGE_TITLE = "Apple Event 2021";

export const GITHUB_SEARCH_TEST_TASK_DESC = "Github Search Test Task";
export const USERS_LIST_TEST_TASK_DESC = "Users list Test Task";
export const HUAWEI_DEVICE_CATALOG_DESC = "HUAWEI Device Gallery";
export const KANBAN_DESC = "Kanban Desk";
export const CURRENCY_CONVERTER_DESC = "Currency Converter";
export const ONLINE_LEARNING_APP_DESC = "IT-Incubator students team project";
export const HUAWEI_NOVA8_LADING_DESC = "Landing Page";
export const UMD_STATIC_SITE_DESC = "Static Site";
export const HUAWEI_WATCH_GT_2_PAGE_DESC = "Flexbox Practice";
export const APPLE_EVENT2021_PAGE_DESC = "Flexbox Practice";

export const GITHUB_SEARCH_TEST_TASK_LINK = "https://github-projects-browser.vercel.app/";
export const USERS_LIST_TEST_TASK_LINK = "https://users-table-task.vercel.app/";
export const HUAWEI_DEVICE_CATALOG_LINK = "https://huawei-device-gallery.vercel.app/";
export const KANBAN_LINK = "https://kanban-desk.vercel.app/";
export const CURRENCY_CONVERTER_LINK = "https://currency-converter-artiomb5.vercel.app/";
export const ONLINE_LEARNING_APP_LINK = "https://hw16.vercel.app/login";
export const HUAWEI_NOVA8_LADING_LINK = "https://huawei-nova-8-5v76xwrl0-artiomb5.vercel.app/";
export const UMD_STATIC_SITE_LINK = "https://miningdepartment.github.io/pages/about.html";
export const HUAWEI_WATCH_GT_2_PAGE_LINK = "https://artiomb5.github.io/Responsive-Flexbox-Layout-Page/";
export const APPLE_EVENT2021_PAGE_LINK = "https://artiomb5.github.io/flexboxappleevent/";

//Skills
export const PUBLIC_SPEAKER_SKILL_TITLE = "Public Speaker";
export const ORGANIZED_SKILL_TITLE = "Organized";
export const ENTHUSIASTIC_TITLE = "Enthusiastic";
export const AVID_LEARNER_TITLE = "Avid Learner";
export const MENTOR_TITLE = "Mentor";
export const SR_TITLE = "Social responsibility";
export const TITLE_1C = "1C:Enterprise 8";

export const PUBLIC_SPEAKER_SKILL_DESC = "I took an active part in organizing corporate leisure. I was a member of the student council of the faculty - editor of the faculty newspaper.";
export const ORGANIZED_SKILL_DESC = "Was vaccinated against COVID-19. I use a respirator in public places, including the office.";
export const ENTHUSIASTIC_DESC = "I took an active part in organizing corporate leisure.";
export const AVID_LEARNER_DESC = "I am constantly improving my qualifications and learning something new.";
export const MENTOR_DESC = "I have mentored some of the interns at the Mining Department and I prepared a number of materials for the internal technical training of employees of the Mining Department.";
export const SR_DESC = "Was vaccinated against COVID-19. I use a respirator in public places, including the office.";
export const DESC_1C = "I have a 1C: Professional certificate";

//About me
export const EMAIL = "artiomb5@yandex.by";
export const GITHUB = "https://github.com/ArtiomB5";

//Experience
export const TC_TITLE = 'Training center No. 1 "Firm 1C"';
export const BNTU_TITLE = 'Belarusian National Technical University';
export const BGHP_TITLE = "Belgorkhimprom JSC";
export const BGHP_MD_TITLE = "Mining department";

export const TC_REQUESTS_DESC = "Requests in the 1C: Enterprise 8 system";
export const TC_FUNDAMENTALS_DESC = "Fundamentals of programming in the 1C: Enterprise 8 system";
export const TC_ADMINISTRATION_DESC = "Introduction to configuration and administration in the 1C: Enterprise 8.3 system.";
export const BNTU_MASTER_TEXT = "Geotechnology (open, underground and construction)";
export const BNTU_MASTER_DESC = "Degree: Master of Engineering Sciences";
export const BNTU_SPECIALIST_TEXT = "Faculty of Mining and Environmental Engineering";
export const BNTU_SPECIALIST_DESC = "Degree: Specialist";

//Footer
export const FOOTER_TITLE = 'Built by Artiom Borisov. Made with ♥ In Belarus';